import { KENO_NUMBER_STATUS, KenoNumber } from '../base/number'
import { LIGHT_THREE_ATLAS_FRAMES, LIGHT_THREE_TEXTURE_KEYS } from '.'
import { STANDARD_LARGE_NUMBER_RATIO } from '@Animation/constants'
import { ANIMATION_IDENTIFIERS } from '@Animation/types'

export class Light3Number extends KenoNumber {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    number: number,
    isPlayerSelected: boolean,
  ) {
    super(scene, x, y, number, isPlayerSelected, ANIMATION_IDENTIFIERS.LIGHT_THREE)
  }

  getGlowAtlasFrame() {
    return LIGHT_THREE_ATLAS_FRAMES.NUMBER_GLOW
  }

  getGlowAtlas() {
    return LIGHT_THREE_TEXTURE_KEYS.ATLAS
  }

  createStatusTextureMap(): { [key in KENO_NUMBER_STATUS]: string } {
    return {
      [KENO_NUMBER_STATUS.DEFAULT]: LIGHT_THREE_TEXTURE_KEYS.NUMBER_DEFAULT,
      [KENO_NUMBER_STATUS.SELECTED_PLAYER]: LIGHT_THREE_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_SYSTEM]: LIGHT_THREE_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_HIT]: LIGHT_THREE_TEXTURE_KEYS.NUMBER_HIT,
    }
  }

  async transitionToSystemSelected(): Promise<void> {
    super.transitionToSystemSelected()

    await this.popNumberTexture(
      LIGHT_THREE_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION,
      STANDARD_LARGE_NUMBER_RATIO,
      1,
    )
  }

  async transitionToSelectedHit() {
    await this.popNumberTexture(
      LIGHT_THREE_TEXTURE_KEYS.NUMBER_HIT_TRANSITION,
      STANDARD_LARGE_NUMBER_RATIO,
      1,
    )

    super.transitionToSelectedHit()
  }
}
